<template>
  <ConfirmGenerateTokenModal />
  <div class="row" v-if="getConfigurations != null">
    <div class="col-lg-12">
      <div class="card mb-25 border-0 radius-7 bg-white letter-spacing">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
          <div class="mt-10" id="myTabContent">
            <form v-on:submit="saveConfigurations()">
              <div class="show active row" id="overviewPreview-tab-pane" role="tabpanel" tabindex="0">

                <div class="d-flex flex-column col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 d-flex">
                  <label for="overviewEmail" class="form-label fw-medium col-6">Limitar armazenamento</label>
                  <div class="d-flex flex-row col-12">

                    <select id="storage_limit" class="form-select shadow-none text-black fs-md-15" required>
                      <option :selected="getConfigurations.storage_limit == null" value="null">Não limitar</option>
                      <option :selected="getConfigurations.storage_limit == '500'" value="500">500 GB</option>
                      <option :selected="getConfigurations.storage_limit == '1000'" value="1000">1 TB</option>
                      <option :selected="getConfigurations.storage_limit == '2000'" value="2000">2 TB</option>
                      <option :selected="getConfigurations.storage_limit == '3000'" value="3000">3 TB</option>
                      <option :selected="getConfigurations.storage_limit == '4000'" value="4000">4 TB</option>
                      <option :selected="getConfigurations.storage_limit == '5000'" value="5000">5 TB</option>
                      <option :selected="getConfigurations.storage_limit == '10000'" value="10000">10 TB</option>
                      <option :selected="getConfigurations.storage_limit == '15000'" value="15000">15 TB</option>
                      <option :selected="getConfigurations.storage_limit == '20000'" value="20000">20 TB</option>
                      <option :selected="getConfigurations.storage_limit == '25000'" value="25000">25 TB</option>
                      <option :selected="getConfigurations.storage_limit == '30000'" value="30000">30 TB</option>
                      <option :selected="getConfigurations.storage_limit == '40000'" value="40000">40 TB</option>
                      <option :selected="getConfigurations.storage_limit == '50000'" value="50000">50 TB</option>
                    </select>

                  </div>
                  <div class="form-text mb-15 mb-mb-15 mb-md-20 col-12">
                    Caso o limite de armazenamento seja atingido, as gravações mais antigas serão deletadas permanentemente para manter o volume desejado. o valor armazenado pode variar para mais ou para menos do valor configurado acima, essa configuração não é exata
                  </div>
                  
                </div>
                
                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <label for="convert_to_gsm" class="form-label fw-medium">Converter as gravações para .gsm?</label>
                  <select id="convert_to_gsm" class="form-select shadow-none text-black fs-md-15" required>
                    <option :selected="getConfigurations.convert_to_gsm == '1'" value="1">Sim</option>
                    <option :selected="getConfigurations.convert_to_gsm == '0'" value="0">Não</option>
                  </select>
                </div>

                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <label for="commercial_phone_01" class="form-label fw-medium">Telefone 1</label>
                  <input
                    :value="getConfigurations.commercial_phone_01"
                    type="tel"
                    class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                    id="commercial_phone_01"
                    autocomplete="off"
                  />
                </div>

                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <label for="commercial_phone_02" class="form-label fw-medium">Telefone 2</label>
                  <input
                    :value="getConfigurations.commercial_phone_02"
                    type="tel"
                    class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                    id="commercial_phone_02"
                    autocomplete="off"
                  />
                  <div class="form-text">Informação opcional.</div>
                </div>

                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <label for="email" class="form-label fw-medium">Email empresarial</label>
                  <input
                    :value="getConfigurations.email"
                    type="email"
                    class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                    id="email"
                    autocomplete="off"
                  />
                </div>

                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <label for="white_label" class="form-label fw-medium">White label</label>
                  <input
                    :value="getConfigurations.white_label"
                    type="white_label"
                    class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                    id="white_label"
                    autocomplete="off"
                  />
                </div>

                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <label for="white_label_logo" class="form-label fw-medium">White label (Logo)</label>
                  <input
                    id="white_label_logo"
                    type="file"
                    class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                    @change="handleFileUpload"
                    accept="image/*"
                  />
                </div>

                <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                  <label for="password" class="form-label fw-medium">Senha</label>
                  <input
                    type="password"
                    class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                    id="password"
                    autocomplete="off"
                    required
                  />
                </div>

                <div class="col-12 justify-content-center d-flex">
                  <button ref="buttonSubmitConfigurationUpdate" type="submit" class="btn btn-primary mt-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">Salvar informações</button>
                </div>

                <div class="col-12">
                  <div id="alertResponseApi" class="toast align-items-center text-bg-success border-0 w-100 mt-3" role="alert" aria-live="assertive" aria-atomic="true">
                    <div class="d-flex">
                      <div class="toast-body fs-md-15 fs-lg-16" id="errorMessage"></div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '../../config/axios.js';
import ConfirmGenerateTokenModal from './ConfirmGenerateTokenModal.vue';


export default {
  name: "FormsOverview",
  data() {
    return {
      responseApi: {},
      imageFile: null,
    }
  },
  components: {
    ConfirmGenerateTokenModal
  },
  computed: {
    ...mapGetters([
      'getConfigurations'
    ])
  },
  watch: {
    getConfigurations(data){
      this.phone1 = data.commercial_phone_01;
      document.title = "Conexão Empresarial";
    }
  },
  methods: {
    handleFileUpload(event) {
      this.imageFile = event.target.files[0];
    },
    closeAlert(){
      const elementAlert = document.getElementById("alertResponseApi");
      if(elementAlert){
        elementAlert.style.display = "none";
      }
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessage").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessage").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApi");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 3000);
      }

      const password = document.getElementById("password");
      if(password){
        password.value = "";
      }
    },
    saveConfigurations(){
      event.preventDefault();

      if(
        document.getElementById("commercial_phone_01") == undefined ||
        document.getElementById("commercial_phone_01").value == "" ||
        document.getElementById("commercial_phone_02") == undefined ||
        document.getElementById("commercial_phone_02").value == "" ||
        document.getElementById("email") == undefined ||
        document.getElementById("email").value == "" ||
        document.getElementById("password") == undefined ||
        document.getElementById("password").value == "" ||
        document.getElementById("password").value.length < 8 ||
        document.getElementById("convert_to_gsm").value == "" ||
        document.getElementById("storage_limit").value == ""
      ){
        this.alertResponse("Erro, verifique os campos e tente novamente !", true);
        return;
      }

      const phone1 = document.getElementById("commercial_phone_01").value;
      const phone2 = document.getElementById("commercial_phone_02").value;
      const email = document.getElementById("email").value;
      const password = document.getElementById("password").value;
      const convert_to_gsm = document.getElementById("convert_to_gsm").value;
      const storage_limit = document.getElementById("storage_limit").value;
      const white_label = document.getElementById("white_label").value;
      
      const formData = new FormData();

      if (this.imageFile) {
        formData.append('image', this.imageFile);
      }

      formData.append('commercial_phone_01', phone1);
      formData.append('commercial_phone_02', phone2);
      formData.append('email', email);
      formData.append('password', password);
      formData.append('convert_to_gsm', convert_to_gsm);
      formData.append('storage_limit', storage_limit);
      formData.append('white_label', white_label);

      const buttonSubmitConfigurationUpdate = this.$refs.buttonSubmitConfigurationUpdate;
      buttonSubmitConfigurationUpdate.disabled = true;
      buttonSubmitConfigurationUpdate.innerHTML = "Atualizando...";

      const alertResponse = this.alertResponse;
        api.axios.post('/api/update/configuration', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        }).catch(function(error){
          if(error.response.data != undefined){
            alertResponse(error.response.data.message, true);
          }
        }).then(function(response){
          buttonSubmitConfigurationUpdate.disabled = false;
          buttonSubmitConfigurationUpdate.innerHTML = "Atualizar informações";
          if(response != undefined && response.status == 200){
            alertResponse(response.data.message, false);
            window.location.reload();
          }
        });

    }
  }
};
</script>

<style scoped>
.form-input-token-custom {
  border-bottom-right-radius: unset !important;
  border-top-right-radius: unset !important;
}

.form-input-button-token-custom {
  border-bottom-left-radius: unset !important;
  border-top-left-radius: unset !important;
}
</style>
